
(function () {

    hanteraSwipe();

    function hanteraSwipe() {
        let touchstartX = 0;
        let touchendX = 0;

        const gestureZone = document.querySelector('.sidhuvud-swipe-zone');

        if (gestureZone) {
            gestureZone.addEventListener('touchstart',
                function(event) {
                    touchstartX = event.changedTouches[0].screenX;
                    touchstartY = event.changedTouches[0].screenY;
                },
                false);

            gestureZone.addEventListener('touchend',
                function(event) {
                    touchendX = event.changedTouches[0].screenX;
                    touchendY = event.changedTouches[0].screenY;
                    handleGesture();
                },
                false);

            function handleGesture() {
                if (touchendX <= touchstartX) {
                    let slickPrev = document.querySelector('.slick-prev');
                    if (slickPrev) {
                        slickPrev.click();
                    }
                }

                if (touchendX >= touchstartX) {
                    let slickNext = document.querySelector('.slick-next');
                    if (slickNext) {
                        slickNext.click();
                    }
                }
            }
        }
    }
})();